import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { policyCollections } from '@services/api'

export class policyCollectionsStore extends StoreExt {
    @observable list = []
    @observable filteredList = []
    @observable filterText = ''
    @observable policy = ''
    @observable collection = {}

    @action
    getList = async policy_id => {
        const { data: list } = await policyCollections.getList({ policy_id: policy_id })
        runInAction(() => {
            this.list = list
            this.filterList(this.filterText)
        })
    }

    @action
    filterList = filterText => {
        this.filterText = filterText
        this.filteredList = this.list.filter(item => `${item.name}`.includes(filterText) || item.id == filterText)
    }

    @action
    addCollection = async (policy_id, collection_id) => {
        await policyCollections.addCollection({ policy_id: policy_id, collection_id: collection_id })
    }

    @action
    deleteCollection = async (policy_id, collection_id) => {
        await policyCollections.deleteCollection({ policy_id: policy_id, collection_id: collection_id })
    }

    @action
    setPolicy = policy => {
        this.policy = policy
    }

    @action
    setCollection = (name, id) => {
        this.collection = { name: name, id: id }
    }
}

export default remotedev(new policyCollectionsStore())
